<div class="blogs-container">
    <!-- Header Section -->
    <div class="blogs-header">
        <div class="header-left">
            <img src="assets/images/icons/dashboard/file_red.png" alt="File Icon" class="file-icon">
            <span class="header-title">
                <span class="title-text">{{ isEditMode ? "Modifier l'article" : "Création d'articles" }} </span>
            </span>
        </div>

        <div class="header-right">
            <button class="add-article-btn" (click)="goToList()">
                <img src="assets/images/icons/back-arrow.png" alt="back" class="add-icon">
                <span>Retour</span>
            </button>
        </div>
    </div>
    <div class="blog-form-container">
        <!-- Success Message -->
        <div *ngIf="showSuccess" class="success-message">
            <div class="success-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#4CB86E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
            </div>
            <p>{{ successMessage }}</p>
            <div class="success-actions">
                <button *ngIf="!isEditMode" type="button" class="btn btn-primary" (click)="createAnother()">
                    Créer un autre article
                </button>
                <button type="button" class="btn btn-cancel" (click)="goToList()">
                    Retour à la liste
                </button>
            </div>
        </div>

        <!-- Loading State -->
        <div *ngIf="isLoading" class="loading-state">
            <div class="loading-spinner"></div>
            <p>Chargement de l'article...</p>
        </div>

        <!-- Main Form -->
        <form *ngIf="!showSuccess && !isLoading" [formGroup]="blogForm" (ngSubmit)="onSubmit()" class="blog-form">
            <div class="form-group">

                <!-- File Upload Area -->
                <div class="file-upload-area" [class.has-file]="selectedFile || previewUrl" (click)="fileInput.click()">
                    <div *ngIf="previewUrl" class="image-preview">
                        <img [src]="previewUrl" alt="Preview" class="preview-image">
                    </div>

                    <!-- Upload Placeholder -->
                    <div *ngIf="!previewUrl" class="upload-placeholder">
                        <img src="assets/images/icons/upload.png" alt="Upload" class="upload-icon">
                        <p class="p-0 m-0">Cliquez pour sélectionner une image</p>
                        <p class="upload-hint">JPG, PNG (max 5MB)</p>
                    </div>

                    <input #fileInput type="file" accept="image/*" (change)="onFileSelected($event)" class="file-input" hidden>
                </div>

                <!-- File Actions -->
                <div *ngIf="selectedFile || existingMainFile" class="file-actions">

                    <span *ngIf="selectedFile" class="file-info">
                        {{ selectedFile.name }}
                    </span>
                    <span *ngIf="existingMainFile" class="file-info">
                        Image existante
                    </span>
                    <button type="button" class="btn btn-sm" (click)="removeFile()">
                        Supprimer
                    </button>
                </div>
            </div>

            <div class="form-group">
                <input type="text" id="title" formControlName="title" class="form-control" [class.is-invalid]="title?.invalid && title?.touched" placeholder="Entrez le titre* de l'article (max 150 caractères)">
                <div *ngIf="title?.invalid && title?.touched" class="form_error">
                    <span *ngIf="title?.errors?.['required']">Le titre est obligatoire</span>
                    <span *ngIf="title?.errors?.['maxlength']">Le titre ne doit pas dépasser 150 caractères</span>
                </div>
                <div class="char-counter">
                    {{ title?.value?.length || 0 }}/150
                </div>
            </div>

            <div class="form-group" #slugInput>
                <input type="text" id="slug" formControlName="slug" class="form-control" [class.is-invalid]="slug?.invalid && slug?.touched" placeholder="Lien URL (votre url ne doit pas contenir d'espace, séparez les mots par des '_' ou généré automatiquement)">
                <div *ngIf="slug?.invalid && slug?.touched" class="form_error">
                    <span *ngIf="slug?.errors?.['required']">Le slug est obligatoire</span>
                </div>
                <div *ngIf="slugAlreadyExists" class="form_error">
                    <span>Un article utilise déjà ce slug. Merci d’en choisir un autre.</span>
                </div>
                <div class="help-text">
                    Laissez ce champ vide pour générer automatiquement l’URL. <br>Si vous souhaitez la définir vous-même, n’utilisez pas d’espace : séparez les mots avec des « _ ».
                </div>
            </div>

            <div class="form-group">
                <textarea id="excerpt" formControlName="excerpt" class="form-control textarea" rows="4" [class.is-invalid]="excerpt?.invalid && excerpt?.touched" placeholder="Court extrait de l'article (max 200 caractères)" maxlength="200"></textarea>
                <div *ngIf="excerpt?.invalid && excerpt?.touched" class="error-message">
                    <span *ngIf="excerpt?.errors?.['maxlength']">L'extrait ne doit pas dépasser 200 caractères</span>
                </div>
                <div class="helper-container">
                    <div class="help-text">
                        L’extrait sera utilisé comme description de l’article lors du partage.
                    </div>
                    <div class="char-counter">
                        {{ excerpt?.value?.length || 0 }}/200
                    </div>
                </div>

            </div>

            <!-- Rich Text Editor -->
            <div class="form-group">
                <div class="editor-container">
                    <quill-editor id="content" formControlName="content" [modules]="editorModules" [class.is-invalid]="content?.invalid && content?.touched" placeholder="Écrivez votre contenu ici...">
                    </quill-editor>
                </div>
                <div *ngIf="content?.invalid && content?.touched" class="error-message">
                    <span *ngIf="content?.errors?.['required']">Le contenu est obligatoire</span>
                </div>
            </div>

            <!-- Visibility Selector -->
            <div class="form-group">
                <div class="visibility-selector">
                    <div class="visibility-option" [class.selected]="blogForm.get('visible')?.value === true" (click)="setVisibility(true)">
                        <span class="visibility-text"> <span class="status-dot public"></span> Public</span>
                        <p class="visibility-description">L'article sera visible par tous les visiteurs</p>
                    </div>
                    <div class="visibility-option" [class.selected]="blogForm.get('visible')?.value === false" (click)="setVisibility(false)">
                        <span class="visibility-text"><span class="status-dot private"></span>Privé</span>
                        <p class="visibility-description">L'article ne sera visible que par les administrateurs</p>
                    </div>
                </div>
            </div>


            <!-- Form Actions -->
            <div class="form-actions">
                <button type="submit" class="btn btn-primary btn-block" [disabled]="isSubmitting || blogForm.invalid">
                    <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
                    {{ isSubmitting ? 'Enregistrement...' : (isEditMode ? 'Modifier' : 'Confirmer') }}
                </button>
                <button type="submit" class="btn btn-cancel" (click)="goToList()">
                    Annuler
                </button>
            </div>

        </form>
    </div>
</div>